export default {
  name: 'rb-dynamic-grid-column',
  props: {
    index: {
      type: Number,
      default: 0,
    },
    isBanner: {
      type: Boolean,
      default: false,
    },
    isFullColumn: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    filteredSlots() {
      return this.$slots.default.filter((slot) => !!slot.tag)
    },
    currentSlot() {
      return this.filteredSlots[this.index]
    },
  },
  render(createElement) {
    let column = 'col'
    if (this.isBanner) {
      if (this.filteredSlots.length > 2) {
        column = 'col-6 dynamic-grid-tile'
      } else {
        column = 'col-12 dynamic-grid-tile'
      }
    }
    if (this.isFullColumn) {
      column = 'col-12'
    }
    return createElement('div', { class: column }, [this.currentSlot])
  },
}
